import script from "./category.vue?vue&type=script&setup=true&lang=js"
export * from "./category.vue?vue&type=script&setup=true&lang=js"

import "./category.vue?vue&type=style&index=0&id=7d0952a1&scoped=true&lang=css"

import exportComponent from "/var/www/html/koboeat/test/customer_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d0952a1"]])

export default __exports__